class Result {
  /**
   * Crea una nueva instancia del objeto Result
   * @param {string} code Codigo que representa un error
   * @param {object} exception Contenido de exception en caso de que ocurra o puede ser null
   * @param {object} result representa un resultado que puede variar entre null o un objeto
   */
  constructor (code, exception = null, result = null) {
    this.code = code
    this.exception = exception
    this.result = result
    switch (code) {
      case 200:
        this.help = 'TODO HA SIDO EJECUTADO CON ÉXITO.'
        break
      case 400:
        this.help = 'NO SE HAN LOCALIZADO DATOS.'
        break
      case 401:
        this.help = 'HA OCURRIDO UN ERROR INTERNO NO CONTROLADO EN EL SERVIDOR.'
        break
      case 4001:
          this.help = 'NO SE HA ENCONTRADO EL CERTIFICADO ELECTRONICO.'
        break
      case 402:
        this.help = 'NO HA SIDO POSIBLE CREAR EL REGISTRO EN LA BASE DE DATOS.'
        break
      case 403:
        this.help = 'ERROR INTERNO DEL SISTEMA, PARAMETROS VACIOS HAN SIDO RECIBIDOS VACIOS.'
        break
      case 404:
        this.help = 'YA EXISTE UN REGISTRO EN LA BASE DE DATOS CON LOS MISMOS DATOS'
        break
      case 405:
        this.help = 'ERROR AL CREAR LA FACTURA'
        break
      case 406:
        this.help = 'ERROR AL CREAR UN ITEM DE LA FACTURA'
        break
      case 500:
        this.help = 'NO HA SIDO POSIBLE EJECUTAR ESTA PETICION EN EL SERVIDOR.'
        break
      case 600:
        this.help = 'LA COMBINACION DE USUARIO Y CONTRASEÑA SUMINISTRADOS NO ES CORRECTA.'
        break
      case 601:
        this.help = 'SU SESION HA EXPIRADO.'
        break
      default:
        this.help = 'ERROR INTERNO NO CONTROLADO, NO IDENTIFICADO'
        break
    }
    // return this
  }
}

class Connector {
  constructor (protocol, disclousure, server, subpath, port, usePort) {
    this.protocol = protocol
    this.disclousure = disclousure
    this.server = server
    this.port = port
    this.usePort = usePort
    this.subpath = subpath
    this.getString = () => {
      // return `${this.protocol}${this.disclousure}${enviroment === 'development' ? this.serverdev : this.serverprod}${this.usePort === true ? ':' + this.port : ''}${this.subpath !== '' ? '/' + this.subpath : ''}`
      return `${this.protocol}${this.disclousure}${this.server}${this.usePort === true ? ':' + this.port : ''}${this.subpath !== '' ? '/' + this.subpath : ''}`
    }
  }
}

export {
  Result,
  Connector
}
